import { createInteractionEvent, createOutcomeEvent } from '../../../utils/EventProviders/EgClickstreamUtil';
import reasons from '../../../components/ListYourPropertyPage/EligibilityCatch/reasons';
import { AAPCL_PROPERTY_INFO } from '../../../components/PageFlow/PageList';

const onError = props => (error) => {
    const {
        onSubmitError,
        setEligibilityStatus,
        pageFlow,
        // add trigger in parent props
        trigger
    } = props;

    trigger('outcome', createOutcomeEvent('property_creation.failed', 'AddProperty', 'AAP'));
    onSubmitError(error.message);
    // AAP flow always defaults to TIMEOUT page
    setEligibilityStatus(reasons.TIMEOUT);
    pageFlow.next(AAPCL_PROPERTY_INFO);
};

const onComplete = props => ({ data }) => {
    const {
        setEligibilityStatus,
        pageFlow,
        setPropertyId,
        // add trigger in parent props
        trigger,
        clearCompetitorUrl,
        clearSubmarketId
    } = props;
    const {
        lpsContact
    } = data.createContact;

    clearCompetitorUrl();
    clearSubmarketId();
    // what happens when we get no property Id???
    if (!lpsContact.propertyId) {
        trigger('outcome', createOutcomeEvent('property_creation.failed', 'AddProperty - no pId', 'AAP'));
        setEligibilityStatus(reasons.TIMEOUT);
        pageFlow.next(AAPCL_PROPERTY_INFO);
        return;
    }
    setPropertyId(lpsContact.propertyId);
    trigger('interaction', createInteractionEvent('next_button.initiated', 'add_a_property', 'AddProperty', '', '2.4.0'));
    trigger('outcome', createOutcomeEvent('property_creation.succeeded', 'AddProperty'));
    pageFlow.next(AAPCL_PROPERTY_INFO);
};

export default {
    onError,
    onComplete
};
